import { pick } from 'lodash';
import React, { useCallback } from 'react';
import { createMeetingFilter } from '../../../../../../data/filters/meetings/createMeetingFilter';
import { createFilter } from '../../../../../../data/filters/schedule/createFilter/createFilter';
import { useScheduleFilter } from '../../../../../../data/hooks/schedule/useScheduleFilter';
import FilteredScheduleTabContent from '../common/FilteredScheduleTabContent/FilteredScheduleTabContent';

function ScheduleSearch(props) {
    const { event, dateFilter, focusedRoundId } = props,
        [fullFilter] = useScheduleFilter(event.id),
        subsetFilter = pick(fullFilter, ['text']),
        filter = useCallback(createFilter(subsetFilter), [fullFilter]),
        meetingsFilter = useCallback(createMeetingFilter(subsetFilter), [fullFilter]),
        hasFilter = !!subsetFilter.text;

    return <FilteredScheduleTabContent event={event} hasFilter={hasFilter} filter={filter} meetingsFilter={meetingsFilter} dateFilter={dateFilter} focusedRoundId={focusedRoundId} />;
}

export default ScheduleSearch;
